import type AppService from 'embercom/services/app-service';
import EmberObject from '@ember/object';
import { A } from '@ember/array';
import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import type IntlService from 'embercom/services/intl';
import type IntercomConfirmService from 'embercom/services/intercom-confirm-service';
import type Store from '@ember-data/store';
import { action } from '@ember/object';

/* RESPONSIBLE TEAM: team-app-security */

export default class AccountAccessController extends Controller {
  @service declare store: Store;
  @service declare intl: IntlService;
  @service declare notificationsService: $TSFixMe;
  @service declare intercomConfirmService: IntercomConfirmService;
  @service declare appService: AppService;

  queryParams = ['createFromMessengerConversation'];

  declare model: $TSFixMe;
  declare impersonationConsents: $TSFixMe;
  declare titleToken: string;

  get app() {
    return this.appService.app;
  }

  get isImpersonationSession() {
    return this.app.impersonation_session;
  }

  hasUnsavedChanges() {
    return this.model.hasDirtyAttributes;
  }

  revertUnsavedChanges() {
    this.model.rollbackAttributes();
  }

  get columns() {
    return A([
      EmberObject.create({
        label: this.intl.t('account.account-access.approved'),
        canExpandToFit: true,
        component: 'table-cells/impersonation-consents/approved-at-cell',
      }),
      EmberObject.create({
        label: this.intl.t('account.account-access.status'),
        canExpandToFit: true,
        component: 'table-cells/impersonation-consents/status-cell',
      }),
    ]);
  }

  get rows() {
    return this.impersonationConsents
      .map((consent: $TSFixMe) => this.buildRow(consent))
      .compact()
      .reverse();
  }

  buildRow(consent: $TSFixMe) {
    if (!consent.get('createdAt')) {
      return;
    }
    return EmberObject.create({ consent });
  }

  @action
  giveConsent() {
    try {
      let consent = this.model.save();
      this.notificationsService.notifyConfirmation(
        this.intl.t('account.account-access.access-confirmation'),
      );
      this.impersonationConsents.pushObject(consent);
    } catch (error) {
      this.notificationsService.notifyError(this.intl.t('account.account-access.access-error'));
    }
  }

  @action
  async revokeConsent() {
    try {
      await this.model.destroyRecord();
      this.notificationsService.notifyConfirmation(
        this.intl.t('account.account-access.revoke-confirmation'),
      );
      this.set('model', this.store.createRecord('admin-impersonation-consent'));
    } catch (error) {
      this.notificationsService.notifyError(this.intl.t('account.account-access.revoke-error'));
    }
  }
}
